var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"br-4",attrs:{"value":_vm.selected,"centered":"","slider-color":"accent","color":"primary","grow":""},on:{"change":(item) => _vm.$emit('change', item)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }